export const DivShowAndHideTypes = {
   SHOW_CREATE_NEW_ODER_SECTION:'SHOW_CREATE_NEW_ODER_SECTION',
   SHOW_REVIEW_ODER_SECTION:'SHOW_REVIEW_ODER_SECTION',
   SHOW_DETAIL_ODER_SECTION:'SHOW_DETAIL_ODER_SECTION',
   SHOW_AVAILABLE_CARD_SECTION:'SHOW_AVAILABLE_CARD_SECTION',
   SHOW_RENDER_TRANSACTION_HISTORY:'SHOW_RENDER_TRANSACTION_HISTORY',
   SHOW_KYC_DETAIL_SUCESS_DIV:'SHOW_KYC_DETAIL_SUCESS_DIV',
   SET_FROM_DASHBOARD:'SET_FROM_DASHBOARD',
   SET_SHOW_CARD_DETAIL_SECTION:'SET_SHOW_CARD_DETAIL_SECTION'
  };